import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import CalcService from "src/services/calc-service"
import ParameterTable from "src/components/table/parameter-table"
import dayjs from "dayjs"
import {DATE_TIME_FORMAT_SHOW} from "src/utils/constants"
import { formatDateUtc } from "src/utils/date-format"

const ParameterCalcEventosCreditoClassificacaoTable = (props) => {
    const calcService = new CalcService()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        calcService.loadEndpoint(props.endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
                'Evento': "N/A",
                'Pattern': "N/A",
                'EventoClassificacao': "N/A",
                'CalculoScore': "N/A",
                'Prioridade': 0,
        }

        props.loading(true)
        return calcService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, Evento, Pattern, EventoClassificacao, CalculoScore, Prioridade } = newRow

        const body = {
            'Evento': Evento,
            'Pattern': Pattern,
            'EventoClassificacao': EventoClassificacao,
            'CalculoScore': CalculoScore,
            'Prioridade': Prioridade,
        }

        props.loading(true)
        return calcService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return calcService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
            minWidth: 70,
        },
        {
            field: 'Evento',
            headerName: 'Evento',
            flex: 1,
            minWidth: 120,
            editable: true
        },
        {
            field: 'Pattern',
            headerName: 'Pattern',
            flex: 1,
            minWidth: 120,
            editable: true
        },
        {
            field: 'EventoClassificacao',
            headerName: 'Evento Classificação',
            flex: 1,
            minWidth: 120,
            editable: true
        },
        {
            field: 'CalculoScore',
            headerName: 'Cálculo do Score',
            flex: 1,
            minWidth: 120,
            editable: true
        },
        {
            field: 'Prioridade',
            headerName: 'Prioridade',
            type: 'number',
            flex: 1,
            minWidth: 70,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                loadData={loadData} />
        </div>
    )
}

ParameterCalcEventosCreditoClassificacaoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterCalcEventosCreditoClassificacaoTable
